<div id="kt_quick_user" class="mat-dialog-container">
	<!--begin::Header-->
	<div class="offcanvas-header d-flex align-items-center justify-content-between pb-5" kt-hidden-height="40">
		<h3 class="font-weight-bold m-0">
			User Profile
		</h3>
	</div>
	<!--end::Header-->

	<!--begin::Content-->
	<div class="offcanvas-content pr-5 mr-n5 scroll ps ps--active-y">
		<!--begin::Header-->
		<div class="d-flex align-items-center mt-5">
			<div class="symbol symbol-100 mr-5">
				<div class="symbol-label">
					<img class="user-picture" [src]="user.profilePicture" alt="User Picture"
						(error)="handleImageError(user)">
				</div>
				<i class="symbol-badge bg-success"></i>
			</div>
			<div class="d-flex flex-column">
				<a href="#" class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary">
					{{user.fullname}}
				</a>
				<div class="text-muted mt-1">
					{{user.role}}
				</div>
				<div class="navi mt-2">
					<a href="#" class="navi-item">
						<span class="navi-link p-0 pb-2">
							<span class="navi-icon mr-1">
								<mat-icon style="height: auto;">email</mat-icon>
								</span>
							<span class="navi-text text-muted text-hover-primary">{{user.email}}</span>
						</span>
					</a>

				</div>
			</div>
		</div>
		<!--end::Header-->

		<!--begin::Separator-->
		<div class="separator separator-dashed mt-8 mb-5"></div>
		<!--end::Separator-->

		<!--begin::Nav-->
		<div class="navi navi-spacer-x-0 p-0">
			<!--begin::Item-->
			<a (click)="editUser(user.uuid)" class="navi-item">
				<div class="navi-link">
					<div class="symbol symbol-40 bg-light mr-3">
						<div class="symbol-label">
							<mat-icon style="width: auto;">person</mat-icon>
						</div>
					</div>
					<div class="navi-text">
						<div class="font-weight-bold">
							My Profile
						</div>
						<div class="text-muted">
							Account settings and more
							<span class="label label-light-danger label-inline font-weight-bold">update</span>
						</div>
					</div>
				</div>
			</a>
			<!--end:Item-->
		</div>